import { useEffect, useRef, useState } from "react";

function ChainDiagram({
  panelSize,
  groundSize,
  match,
  teamA,
  teamB,
  selectedPeriod,
  videoProgress,
  catapultOffset,
  showNames,
  selectedPlayers,
  currentChain,
  selectedEvent,
  onSensorData,
}) {
  const canvas = useRef();
  const ref = useRef(null);
  const [xmargin, setXmargin] = useState(20);
  const [ymargin, setYmargin] = useState(40);
  const [groundWidth, setGroundWidth] = useState(groundSize.width);
  const [groundHeight, setGroundHeight] = useState(groundSize.height);
  const [scale, setScale] = useState(1);
  const [teamAplayers, setTeamAPlayers] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [basecoord, setBaseCoord] = useState(null);
  const intervalRef = useRef(null);

  //   const doDrawPlayer = (ctx, pl, colour, textcolour) => {
  //     for (var n = 0; n < pl?.data?.length; n++) {
  //       const sd = pl.data[n];
  //       const sdtime = sd.ts + sd.cs / 100;
  //       if (sdtime >= currentTime) {
  //         if (sd.x === 0 && sd.y === 0) {
  //           continue;
  //         }
  //         onSensorData({ athleteId: pl.athlete_id, sd: sd });
  //         const xx = -sd.y * scale;
  //         const yy = -sd.x * scale;
  //         let x = panelSize.width / 2 + xx;
  //         let y = panelSize.height / 2 + yy;

  //         for (var nn = n; nn < n + 20; nn++) {
  //           const sdd = pl.data[nn];
  //           if (!sdd || (sdd.x === 0 && sdd.y === 0)) {
  //             continue;
  //           }
  //           const xx = -sdd.y * scale;
  //           const yy = -sdd.x * scale;
  //           let x1 = panelSize.width / 2 + xx;
  //           let y1 = panelSize.height / 2 + yy;
  //           ctx.beginPath();
  //           ctx.moveTo(x, y);
  //           ctx.lineTo(x1, y1);
  //         }
  //         ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
  //         ctx.lineWidth = 2;
  //         ctx.stroke();
  //         ctx.closePath();

  //         // console.log(pl.jersey, x, y, sd.x, sd.y);
  //         ctx.fillStyle = colour;
  //         ctx.beginPath();
  //         ctx.arc(x, y, 8, 0, Math.PI * 2);
  //         ctx.fill();
  //         if (
  //           selectedPlayers.filter((plx) => plx.id === pl.athlete_id).length > 0
  //         ) {
  //           ctx.strokeStyle = "red";
  //           ctx.lineWidth = 2;
  //           ctx.stroke();
  //         }
  //         if (
  //           currentChain &&
  //           currentChain.events.filter((obj) => obj.athleteId === pl.athlete_id)
  //             .length > 0
  //         ) {
  //           ctx.strokeStyle = "#FF5F1F";
  //           ctx.lineWidth = 2;
  //           ctx.stroke();
  //         }
  //         writeText(
  //           {
  //             ctx: ctx,
  //             text: pl.jersey,
  //             x: x,
  //             y: y - 4,
  //           },
  //           {
  //             textAlign: "center",
  //             font: "Arial",
  //             fontSize: 10,
  //             color: textcolour,
  //           }
  //         );
  //         if (showNames) {
  //           ctx.beginPath();
  //           var width = ctx.measureText(pl.athlete_last_name).width;
  //           ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
  //           ctx.fillRect(x - width / 2, y + 8, width, 10);
  //           writeText(
  //             {
  //               ctx: ctx,
  //               text: pl.athlete_last_name.toUpperCase(),
  //               x: x,
  //               y: y + 10,
  //             },
  //             {
  //               textAlign: "center",
  //               font: "Arial",
  //               fontSize: 8,
  //               color: "white",
  //             }
  //           );
  //         }
  //         break;
  //       }
  //     }
  //   };

  const draw = () => {
    const ctx = canvas.current.getContext("2d");
    const sc = drawGround(ctx);
    if (currentChain) {
      let lastx = 0;
      let lasty = 0;
      for (var e of currentChain.events) {
        const xx = -parseFloat(e["chainy"]) * sc;
        const yy = -parseFloat(e["chainx"]) * sc;
        let x = panelSize.width / 2 + xx;
        let y = panelSize.height / 2 + yy;
        if (lastx !== 0 && lasty !== 0) {
          ctx.beginPath();
          ctx.moveTo(lastx, lasty);
          ctx.lineTo(x, y);
          ctx.strokeStyle = "rgba(255, 255, 0, 0.6)";
          ctx.lineWidth = 2;
          ctx.stroke();
          ctx.closePath();
        }
        lastx = x;
        lasty = y;
        ctx.fillStyle = "rgba(255, 255, 0, 0.6)";
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, Math.PI * 2);
        ctx.fill();
        if (selectedEvent === e) {
          ctx.strokeStyle = "red";
          ctx.lineWidth = 2;
          ctx.stroke();
        }
      }
    }
    // if (
    //   teamA &&
    //   teamA.show === true &&
    //   teamA.playerSensorData &&
    //   teamA.playerSensorData[selectedPeriod - 1]
    // ) {
    //   for (var pl of teamA?.catapultPlayers) {
    //     doDrawPlayer(
    //       ctx,
    //       pl.playerSensorData[selectedPeriod - 1],
    //       "blue",
    //       "white"
    //     );
    //   }
    // }
    // if (
    //   teamB &&
    //   teamB.show === true &&
    //   teamB.playerSensorData &&
    //   teamB.playerSensorData[selectedPeriod - 1]
    // ) {
    //   for (var pl of teamB?.catapultPlayers) {
    //     doDrawPlayer(
    //       ctx,
    //       pl.playerSensorData[selectedPeriod - 1],
    //       "cyan",
    //       "black"
    //     );
    //   }
    // }
  };

  const drawGround = (ctx) => {
    const { width, height } = panelSize;

    // Set the canvas size
    canvas.current.width = width;
    canvas.current.height = height;

    const ww = width - 2 * xmargin;
    const sc = ww / groundSize.width;
    setScale(sc);
    const hh = groundSize.height * sc;
    setGroundWidth(ww);
    setGroundHeight(hh);
    const topy = (height - hh) / 2;
    setYmargin(topy);
    const bottomy = hh + topy;
    const m50 = 50 * sc;
    const m25 = 25 * sc;
    const m10 = 10 * sc;
    const m9 = 9 * sc;
    const m3 = 3 * sc;
    // Draw the ground
    ctx.fillStyle = "darkgreen";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "green";
    ctx.beginPath();
    ctx.ellipse(width / 2, height / 2, ww / 2, hh / 2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = "white";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.save();
    ctx.clip();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, topy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, bottomy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    ctx.strokeRect(width / 2 - m25, height / 2 - m25, m50, m50);
    ctx.strokeRect(width / 2 - m9 / 2, topy, m9, m9);
    ctx.strokeRect(width / 2 - m9 / 2, bottomy - m9, m9, m9);
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m3 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m10 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(width / 2 - m10 / 2, height / 2);
    ctx.lineTo(width / 2 + m10 / 2, height / 2);
    ctx.stroke();
    ctx.restore();

    return sc;
  };

  const startTimer = () => {
    setIsActive(true);
    intervalRef.current = setInterval(() => {
      setCurrentTime((prev) => prev + 0.1);
    }, 100);
    // console.log(currentTime);
  };

  //   const pauseTimer = () => {
  //     setIsActive(false);
  //     clearInterval(intervalRef.current);
  //   };

  //   const resetTimer = () => {
  //     setIsActive(false);
  //     setCurrentTime(
  //       match.home_catapult_session.periods[selectedPeriod - 1].start_time
  //     );
  //     clearInterval(intervalRef.current);
  //   };

  const doInit = async () => {
    // setCurrentTime(
    //   match.home_catapult_session.periods[selectedPeriod - 1].start_time + 10
    // );
    // startTimer();
  };

  useEffect(() => {
    doInit();
    draw();
  }, [panelSize, groundSize]);

  useEffect(() => {
    // console.log(currentTime);
    draw();
  }, [currentTime]);

  useEffect(() => {
    // // console.log(videoProgress);
    // setCurrentTime(
    //   match.home_catapult_session?.periods[selectedPeriod - 1].start_time +
    //     videoProgress +
    //     catapultOffset
    // );
    // //   startTimer();
  }, [videoProgress]);

  return (
    <div className="ChainDiagram" ref={ref}>
      <canvas
        ref={canvas}
        // onMouseDown={mousedown}
        // onMouseMove={mousemove}
        // onMouseUp={mouseup}
        // onTouchStart={touchstart}
        // onTouchMove={touchmove}
        // onTouchEnd={touchend}
        width={panelSize?.width}
        height={panelSize?.height}
        // style={{ border: "1px solid #ff0000" }}
      ></canvas>
    </div>
  );
}

export default ChainDiagram;
